import { Component } from '@angular/core';

@Component({
  selector: 'app-contact-component',
  imports: [],
  templateUrl: './contact-component.html',
})
export class ContactComponent {
  email = 'kidsgonflablesparty@gmail.com';
  telephone = '92.34.61';
  messengerLink = 'https://m.me/KidsGonflables';
}
